import useRequest from '@/websdk/utils/request';

export default (function () {
  const { data, exec } = useRequest({
    name: 'GET_PRODUCTION_ORDERS',
    url: '/api/work-orders',
    manual: false,
  });

  return [data || [], exec];
});
